<template>
    <div class="animated fadeIn">        
        <b-card>
            <div slot="header">
                Form - Order Pasang Iklan - Digital Platform 
                <div class="card-header-actions">
                <button  class="btn btn-primary mr-1" @click="save()" v-if="saveEnabled"><i class="fa fa-save" ></i> Save</button>
                <b-button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close Form</b-button>
                </div>
            </div>
              <b-row class="expand-input">
                <b-col lg="6">
                  <b-input-group >
                    <b-input-group-prepend><label>Nomor OPI</label></b-input-group-prepend>
                    <b-form-input v-model="model.orderno" readonly placeholder="AUTO NUMBERING" v-b-tooltip.hover title="Auto Numbering" ></b-form-input>
                    <b-input-group-prepend><span class="ml-2 mr-1 pt-2">Tanggal OPI</span></b-input-group-prepend>
                    <b-form-input v-model="model.orderdate" :state="$v.model.orderdate.$dirty ? !$v.model.orderdate.$error : null" type="date" class="mr-2"></b-form-input>
                  </b-input-group>
                  <b-row>
                      <b-col lg="7">
                        <b-input-group >
                            <b-input-group-prepend><label>Sales Order</label></b-input-group-prepend>
                            <b-form-input placeholder="Pilih Sales Order" v-model="model.mediaorder" readonly></b-form-input>
                            <b-input-group-append>
                              <b-btn variant="primary" text="Button" @click="lkuSoShow=true" v-if="(!(model.orderid))">
                                  <i class="fa fa-search"></i>
                              </b-btn>
                            </b-input-group-append>
                        </b-input-group>
                      </b-col>
                  </b-row>
                  <b-input-group >
                      <b-input-group-prepend><label>Pemasang</label></b-input-group-prepend>
                      <b-form-input placeholder="Masukkan Nama Pemasang" v-model="model.pemasang" ></b-form-input>
                      <b-input-group-prepend><span class="input-group-text">u.p Invoice</span></b-input-group-prepend>
                  </b-input-group>
                  <b-input-group >
                      <b-input-group-prepend><label>Nama Biro Iklan</label></b-input-group-prepend>
                      <b-form-input placeholder="Pilih Biro Iklan" v-model="model.custinfo" :state="$v.model.customer_id.$dirty ? !$v.model.customer_id.$error : null" readonly></b-form-input>
                      <!-- <b-input-group-append>
                        <b-btn variant="primary" text="Button" @click="lkuCustomerShow=true" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                      </b-input-group-append> -->
                  </b-input-group>
                  <b-input-group >
                      <b-input-group-prepend><label>Advertiser</label></b-input-group-prepend>
                    <b-form-input placeholder="Masukkan Advertiser" v-model="model.Advertiser" disabled></b-form-input>
                  </b-input-group>
                  <b-input-group >
                      <b-input-group-prepend><label>Brand</label></b-input-group-prepend>
                      <b-form-input placeholder="Masukkan Brand" v-model="model.brand" disabled></b-form-input>
                      <b-input-group-prepend><span class="ml-2 mr-1 pt-2">Category</span></b-input-group-prepend>
                    <b-form-input placeholder="Masukkan Category" v-model="model.kategori" disabled></b-form-input>
                  </b-input-group>
                  <b-input-group >
                    <b-input-group-prepend><label>Nama Sales AE</label></b-input-group-prepend>
                    <b-form-input placeholder="Pilih Sales AE" v-model="model.SalesEx" readonly></b-form-input>
                    <b-input-group-append>
                      <b-btn variant="primary" text="Button" @click="lkuSalesaeShow=true" >
                          <i class="fa fa-search"></i>
                      </b-btn>
                    </b-input-group-append>
                  </b-input-group>
                  <b-input-group >
                    <b-input-group-prepend><label>Platform Digital</label></b-input-group-prepend>
                    <b-form-radio-group v-model="model.platform"  :options="platforms" :state="!$v.model.platform.$error" class="p-2"></b-form-radio-group>
                  </b-input-group>
                  <b-input-group >
                    <b-input-group-prepend><label>Jenis Iklan</label></b-input-group-prepend>
                    <b-form-input placeholder="Pilih Jenis Iklan"  v-model="model.jiklan" :state="!$v.model.jiklanid.$error" readonly style="width:50% !important;"></b-form-input>
                    <b-input-group-append>
                        <b-btn variant="primary" text="Button" @click="lkuJenisIklanShow=true" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                      </b-input-group-append>
                    <b-input-group-prepend><span class="p-2">Konten</span></b-input-group-prepend>
                    <b-form-select v-model="model.materijadi" :plain="true" :options="konteniklans"></b-form-select>
                  </b-input-group>
                  <b-input-group >
                    <b-input-group-prepend><label >Size / Position</label></b-input-group-prepend>
                    <b-form-input v-model="model.ukuraniklan" ></b-form-input>
                    <b-input-group-append><span class="input-group-text"> Page/Canal </span></b-input-group-append>
                    <b-form-input v-model="model.posisirubrik"  ></b-form-input>
                  </b-input-group>
                  <b-input-group >
                    <b-input-group-prepend><label>Judul Iklan/Note</label></b-input-group-prepend>
                    <b-form-input placeholder="Judul/Keterangan" maxlength="250" v-model="model.juduliklan" :state="$v.model.juduliklan.$dirty ? !$v.model.juduliklan.$error : null"></b-form-input>
                  </b-input-group>
                </b-col>
                <b-col lg="6">                  
                    <b-input-group >
                      <b-input-group-prepend><label>Total SPOT Kontrak</label></b-input-group-prepend>
                      <b-form-input v-model="model.jmlspot" type="number" :state="$v.model.jmlspot.$dirty ? !$v.model.jmlspot.$error : null"></b-form-input>
                      <b-input-group-append><span class="input-group-text"> spot </span></b-input-group-append>
                      <b-input-group-prepend><span class="p-2"> Jml.Jadwal </span></b-input-group-prepend>
                      <b-form-input v-model="model.jmljadwal" type="number" readonly ></b-form-input>
                      <b-input-group-append><span class="input-group-text"> hari </span></b-input-group-append>
                      <b-input-group-prepend><span class="p-2"> Spot Jadwal </span></b-input-group-prepend>
                      <b-form-input v-model="model.jmlspotjadwal" type="number" readonly ></b-form-input>
                      <b-input-group-append><span class="input-group-text"> spot </span></b-input-group-append>
                  </b-input-group>
                  <b-input-group >
                      <b-input-group-prepend><label>Nilai Kontrak ({{uanguser}})</label></b-input-group-prepend>
                      <my-number class="form-control text-right" v-model="model.gross" :precision="2"  style="width:15% !important;"></my-number>
                      <b-input-group-prepend><span class="pl-2 pt-2">Harga per Spot</span></b-input-group-prepend>
                      <my-number v-model="model.price" class="text-right" readonly></my-number>
                      <b-input-group-append><span class="pl-2 pt-2">Rate Card </span></b-input-group-append>
                      <my-number v-model="model.ratecard" class="text-right" readonly></my-number>
                  </b-input-group>

                  <b-table
                    class="mb-0"
                    ref="table"
                    outlined responsive hover small
                    style="font-size:smaller;" 
                    :items="orderLines"
                    :fields="ordLines.fields" 
                    :current-page="ordLines.page"
                    :per-page="ordLines.limit"
                    show-empty
                  >
                    <template v-slot:cell(index)="data">
                      {{ (ordLines.page - 1) * ordLines.limit + (data.index + 1)}}
                    </template>
                    <template v-slot:cell(jadwalmuat)="data">
                      <span v-if="(data.item.jadwalmuat)"> {{data.item.jadwalmuat | ambilNamaHari}}, {{data.item.jadwalmuat| moment('DD MMM YYYY')}} </span>
                    </template>
                    <template v-slot:cell(nilai)="data">
                      {{data.item.nilai|numFormat('0,0.00')}}
                    </template>
                        <template v-slot:cell(action)="data">
                            <div class="text-center">
                            <a href="javascript:void(0)" @click="editOrderLines(data.item,data.toggleDetails)">
                                <i class="fa fa-pencil"></i>
                            </a>
                            |
                            <a href="javascript:void(0)" class="text-danger" @click="delOrderLines(data.index)">
                                <i class="fa fa-trash"></i>
                            </a>
                            </div>
                        </template>
                        <template v-slot:row-details="row">
                            <b-card class="row-details-form">
                              <b-row no-gutters>
                                  <b-col md="8">                            
                                      <b-input-group>
                                          <b-input-group-prepend><label>Jadwal Tayang</label></b-input-group-prepend>
                                          <b-form-input v-model="ordLinesObj.jadwalmuat" :state="$v.ordLinesObj.jadwalmuat.$dirty ? !$v.ordLinesObj.jadwalmuat.$error : null" type="date" class="mr-2"></b-form-input>
                                      </b-input-group>
                                  </b-col>
                                  <b-col md="4">                            
                                      <b-input-group>
                                          <b-input-group-prepend><span class="p-2">Jml.Tayang</span></b-input-group-prepend>
                                          <b-form-input v-model="ordLinesObj.jadwalspot" type="number" v-b-tooltip.hover :title="`Qty: ${ordLinesObj.jadwalspot}`" :state="!$v.ordLinesObj.jadwalspot.$error" min="1"></b-form-input>
                                          <b-input-group-append><span class="input-group-text"> spot </span></b-input-group-append>
                                      </b-input-group>
                                  </b-col>
                              </b-row >
                              <b-row class="justify-content-center">
                                  <div style="width:350px;">
                                      <b-input-group >
                                          <b-input-group-prepend><span class="p-2">Input Jadwal berlanjut</span></b-input-group-prepend>
                                          <b-form-checkbox v-model="inputLineBerlanjut" :value="1" :unchecked-value="0"  class="pt-2"></b-form-checkbox>
                                          <b-input-group-append>
                                              <b-button class="btn btn-success mr-1" @click="saveOrderLines()">Update</b-button>
                                          </b-input-group-append>
                                          <b-input-group-append>
                                              <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                                          </b-input-group-append>
                                      </b-input-group >
                                  </div>
                              </b-row>
                            </b-card>
                        </template>
                        <template v-slot:cell(empty)="scope">
                            <h4>{{ scope.emptyText }}</h4>
                        </template>
                        <template v-slot:cell(emptyfiltered)="scope">
                            <h4>{{ scope.emptyFilteredText }}</h4>
                        </template>                        

                  </b-table>
                  <b-row class="mb-0">
                      <b-col cols="8" class="mb-0">
                          <b-row class="mb-0"> 
                          <b-button size="sm" class="ml-3" @click.stop="addOrderLines" >Add Jadwal</b-button>                          
                          <div class="ml-2">
                              Total {{ordLines.total}} Jadwal, 
                              ditampilkan
                              <input type="number" style="width:50px;" v-model="ordLines.limit"/>
                              <strong v-if="(ordLines.total)">
                              {{(ordLines.page - 1) * ordLines.limit + 1}}
                              dari
                              {{ordLines.page * ordLines.limit}}
                              </strong>
                          </div>    
                          </b-row>
                      </b-col>
                      <b-col cols="4" class="mb-0">            
                        <b-pagination
                            align="right"
                            :total-rows="ordLines.total"
                            :per-page="ordLines.limit"
                            v-model="ordLines.page"
                        ></b-pagination>
                      </b-col>
                  </b-row>

                </b-col>
              </b-row>
              <hr>
            <b-row>
               <b-col lg="6">
                  <b-input-group >
                    <b-input-group-prepend><label>Bentuk Pembayaran</label></b-input-group-prepend>
                    <b-form-select v-model="model.jenisbayar" :options="paymentForms" :plain="true" class="mr-2" disabled></b-form-select>
                  </b-input-group>
               </b-col>
            </b-row>
              <!-- <b-row class="expand-input">
                <b-col lg="6">
                  <b-row>
                    <b-col md="7">
                      <b-input-group >
                        <b-input-group-prepend><label>Gross</label></b-input-group-prepend>
                      </b-input-group>
                    </b-col>
                    <b-col md="5">
                      <b-input-group >
                        <b-input-group-append><span class="input-group-text"> {{uanguser}} </span></b-input-group-append>
                        <my-number class="form-control text-right" v-model="model.gross" :precision="2" disabled></my-number>
                      </b-input-group>                      
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="7">
                      <b-input-group >
                        <b-input-group-prepend><label>Discount</label></b-input-group-prepend>
                        <b-form-select v-model="model.calcDisc" :plain="true" :options="calcuationDisc"  style="width:25% !important;" disabled></b-form-select>
                        <my-number class="text-right ml-1" v-model="model.diskonpc" :readonly="(model.calcDisc===0)" :precision="2" v-b-tooltip.hover :title="model.diskonpc" disabled></my-number>
                        <b-input-group-append><span class="input-group-text">%</span></b-input-group-append>
                      </b-input-group>
                    </b-col>
                    <b-col md="5">
                      <b-input-group >
                        <b-input-group-append><span class="input-group-text"> {{uanguser}} </span></b-input-group-append>
                        <my-number class="form-control text-right" v-model="model.diskon" :readonly="(model.calcDisc===1)" :precision="2" disabled></my-number>
                      </b-input-group>                      
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="7">
                    <b-input-group >
                      <b-input-group-prepend><label>Revenue Lain</label></b-input-group-prepend>
                      <b-form-input v-model="model.revlaindesc"  placeholder="contoh: pembuatan materi" disabled></b-form-input>
                    </b-input-group>
                    </b-col>
                    <b-col md="5">
                      <b-input-group >
                        <b-input-group-append><span class="input-group-text"> {{uanguser}} </span></b-input-group-append>
                        <my-number class="form-control text-right" v-model="model.revlain" :precision="2" disabled></my-number>
                      </b-input-group>                                            
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col md="7">
                      <b-input-group >
                        <b-input-group-prepend><label>Netto</label></b-input-group-prepend>
                      </b-input-group>
                    </b-col>
                    <b-col md="5">
                      <b-input-group >
                        <b-input-group-append><span class="input-group-text"> {{uanguser}} </span></b-input-group-append>
                        <my-number class="form-control text-right" v-model="model.dpp" :precision="2" disabled></my-number>
                      </b-input-group>                      
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="7">
                      <b-input-group >
                        <b-input-group-prepend><label>PPN</label></b-input-group-prepend>
                        <b-form-select v-model="model.calcVAT" :plain="true" :options="calcuationVAT" style="width:37% !important;" disabled></b-form-select>
                        <b-form-input :value="tarifPPN" readonly class="text-right ml-1"></b-form-input>
                        <b-input-group-append><span class="input-group-text">%</span></b-input-group-append>
                      </b-input-group>
                    </b-col>
                    <b-col md="5">
                      <b-input-group >
                        <b-input-group-append><span class="input-group-text"> {{uanguser}} </span></b-input-group-append>
                        <my-number class="form-control text-right" v-model="model.ppn" :readonly="(model.calcVAT===1)" :precision="2"></my-number>
                      </b-input-group>                      
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="7">
                      <b-input-group >
                        <b-input-group-prepend><label>Grand Total</label></b-input-group-prepend>
                      </b-input-group>
                    </b-col>
                    <b-col md="5">
                      <b-input-group >
                        <b-input-group-append><span class="input-group-text"> {{uanguser}} </span></b-input-group-append>
                        <my-number class="form-control text-right" v-model="model.total" :precision="2" readonly></my-number>
                      </b-input-group>                      
                    </b-col>
                  </b-row>
                </b-col>
                <b-col lg="6">
                    <b-row no-gutters>
                        <b-col lg="6">
                            <b-input-group >
                            <b-input-group-prepend><label>Bentuk Pembayaran</label></b-input-group-prepend>
                            <b-form-select v-model="model.jenisbayar" :options="paymentForms" :plain="true" class="mr-2"></b-form-select>
                            </b-input-group>
                        </b-col>
                        <b-col lg="6">
                            <b-input-group >
                                <b-input-group-prepend><span class="input-group-text">Cara Bayar</span></b-input-group-prepend>
                                <b-form-radio-group inline class="p-1" v-model="model.iscash" >
                                    <b-form-radio value=0>Invoicing</b-form-radio>
                                    <b-form-radio value=1>Tunai (dimuka)</b-form-radio>
                                </b-form-radio-group>
                            </b-input-group>
                        </b-col>
                    </b-row>
                    <b-row no-gutters v-if="(model.iscash!=1)">
                        <b-col lg="6">
                            <b-input-group >
                                <b-input-group-prepend><label>Billing Invoice</label></b-input-group-prepend>
                                <b-form-select v-model="model.billing" :options="invoicingTerms" :plain="true" class="mr-2"></b-form-select>
                            </b-input-group>
                        </b-col>
                        <b-col lg="6" >
                            <b-input-group >
                                <b-input-group-prepend><span class="input-group-text">Tujuan Invoice</span></b-input-group-prepend>
                                <b-form-radio-group inline class="p-1" v-model="model.billtoadv" >
                                    <b-form-radio value=0>Agency</b-form-radio>
                                    <b-form-radio value=1>Advertiser</b-form-radio>
                                </b-form-radio-group>
                            </b-input-group>
                        </b-col>
                    </b-row>
                    <b-input-group v-if="(model.billing=='PER TERMIN')">
                        <b-input-group-prepend><label>Termin Invoicing</label></b-input-group-prepend>
                        <b-form-input v-model="model.keteranganbayar" placeholder="Keterangan Termin Invoicing" class="mr-5"></b-form-input>
                    </b-input-group>

                  <div class="bordered"></div>
                  <transition name="slide-fade">
                    <div v-if="model.billtoadv === '1' || model.billtoadv === 1">
                      <b-input-group>
                        <b-input-group-prepend><label>Nama Advertiser</label></b-input-group-prepend>
                        <b-form-input v-model="model.advnama" placeholder="Nama Advertiser sesuai NPWP" style="width:40% !important;"></b-form-input>
                        <b-input-group-prepend><span class="ml-2 pt-2 mr-1">NPWP</span></b-input-group-prepend>
                        <b-form-input v-model="model.advnpwp" placeholder="NPWP"></b-form-input>
                      </b-input-group>
                      <b-input-group>
                        <b-input-group-prepend><label>Alamat Advertiser</label></b-input-group-prepend>
                        <b-form-input v-model="model.advaddr1" placeholder="Alamat 1"></b-form-input>
                      </b-input-group>
                      <b-input-group>
                        <b-input-group-prepend><label> </label></b-input-group-prepend>
                        <b-form-input v-model="model.advaddr2" placeholder="Alamat 2"></b-form-input>
                      </b-input-group>
                      <b-input-group>
                        <b-input-group-prepend><label>Telepon</label></b-input-group-prepend>
                        <b-form-input v-model="model.advtelp" placeholder="No Telepon"></b-form-input>
                        <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Fax</span></b-input-group-prepend>
                        <b-form-input v-model="model.advcity" placeholder="No. Fax"></b-form-input>
                      </b-input-group>
                    </div>
                  </transition>
                  </b-col>
              </b-row>
            <hr> -->
            <b-row class="justify-content-center mb-2">
                <b-input-group-prepend><span class="p-2">remain on Form after save</span></b-input-group-prepend>
                  <b-form-checkbox v-model="inputBerlanjut" :value="1" :unchecked-value="0"  class="pt-2"></b-form-checkbox>
                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close Form</button>
            </b-row>

        </b-card>
        <b-modal v-model="lkuCustomerShow" size="lg" :hide-footer="true" title="List of Customer" :centered="true" :lazy="true">
            <lku-customer @click="onSelectLkuCustomer"></lku-customer>
        </b-modal>   
        <b-modal v-model="lkuSalesaeShow" size="lg" :hide-footer="true" title="List of Sales AE" :centered="true" :lazy="true">
            <lku-salesae @click="onSelectLkuSalesae" crudfilter="iklan=1"></lku-salesae>
        </b-modal> 
         <b-modal v-model="lkuJenisIklanShow" size="lg" :hide-footer="true" title="Jenis Iklan Digital" :centered="true" :lazy="true">
            <lku-jenisiklan @click="onSelectLkuJenisIklan" :platformid="this.model.platform" :key="this.model.platform" ></lku-jenisiklan>
        </b-modal>  
        <b-modal v-model="lkuSoShow" size="lg" :hide-footer="true" title="List of Sales Order (Customer P.O)"  :key="model.customer_id" :centered="true">
            <lku-salesorder @click="onSelectLkuSo" iklandigital="1" statusopi="0" :byae="byae"></lku-salesorder>
            <!-- <lku-salesorder @click="onSelectLkuSo" :customer="model.custinfo" :customer_id="model.customer_id" iklandigital="1" statusopi="0" :byae="byae"></lku-salesorder> -->
        </b-modal>        

    </div>
</template>
<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 90px;
            }
        }
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }
</style>

<script>
import toastr from "mini-toastr";
// import VCalendar from 'v-calendar';
import opi from "../../apis/koran_opidigital";
import moment from 'moment';
import accounting from 'accounting-js'
import myNumber from "../../components/my-number";
import { validationMixin } from "vuelidate";
import { required, minValue } from "vuelidate/lib/validators";
import lkuCustomer from "../lookup/lkuCustomer";
import lkuSalesae from "../lookup/lkuSalesae";
import lkuJenisiklan from "../lookup/lkuJenisIklandigital";
import lkuSalesorder from "../lookup/lkuSalesOrderLine";


toastr.init();


function compareNumbers(a, b) {
  return a - b;
}
export default {
  mixins: [validationMixin],
  validations: {
    model: {
        platform: { required }, 
        orderdate: { required }, 
        customer_id: { required }, 
        juduliklan: { required },
        jiklanid: { required },
        jmlmuat: { required, minValue:minValue(1) },
        jmlspot: { required, minValue:minValue(1) },
    },
    ordLinesObj: {
        jadwalmuat: { required },
        jadwalspot: { required },
    },

  }, 
  components:{myNumber, lkuCustomer, lkuSalesae, lkuJenisiklan, lkuSalesorder},
  data() {
    return {
      inputBerlanjut:1,
      lkuCustomerShow: false,
      lkuSalesaeShow: false,
      lkuJenisIklanShow: false,
      lkuSoShow: false,
      lkuSoData:{},
      selectedIklan: {},
      saveEnabled:true,
      minDate: new Date(),
      uanguser: this.$store.state.user.matauang,
      options_ispaket: [
          { text: 'Satuan', value: '0' },
          { text: 'Paket/Kontrak', value: '1' }
      ],
      inputLineBerlanjut: 1,
      orderLines:[], tgl_akan_muat:[],
      ordLinesObj: {
          jadwalmuat: '',
          jadwalspot: 1
      },
      ordLines: {
          selected:{},
          fields:[
              {
                key: "index",
                label: "No",
              },
              {
                key: "jadwalmuat",
                label: "Jadwal",
                sortable: true
              },
              {
                key: "jadwalspot",
                label: "Jml.Spot",
              },
              {
                key: "action",
                label: "Action",
                thStyle: "width:60px",
                thClass: "text-center",
              } 
            ],
          page: 1,
          limit: 10,
          total: 0,
      },
      calcuationVAT : [{ value: 1, text: 'VAT (Auto Calc)' }, { value: 0, text: 'VAT (Manual Calc)' }],
      calcuationDisc : [{ value: 1, text: 'Disc (Auto Calc)' }, { value: 0, text: 'Disc (Manual Calc)' }],
      paymentForms:[{value:'STANDARD', text: 'Standard Cash/Bank'}],
      invoicingTerms:[
          {value:'DI AWAL', text: 'DI AWAL'},
          {value:'PER TERMIN', text: 'PER TERMIN'},
            {value:'PER TAYANG', text: 'PER TAYANG'},
            {value:'PER BULAN', text: 'PER BULAN'},
            {value:'DI AKHIR', text: 'DI AKHIR'}
      ],
        tarifPPN: this.$store.state.user.tarifppn || 10,
      model:{
        platform: 'Desktop',orderid:'',
        orderno: '',calcVAT:1, calcDisc:1,
        orderdate: moment().format('YYYY-MM-DD'), 
        pemasang: '', 
        custinfo: '',
        customer_id: '', 
        customer_name: '', 
        Advertiser: '', 
        mediaorder: '', 
        juduliklan: '', 
        ukuraniklan: '', 
        jmlspot: 0, 
        jmlspotjadwal: 0, 
        ispaket: 1,
        jmlmuat: 0,
        jmljadwal: 0,
        kategori: '',
        brand: '',
        jiklanid: '',
        jiklan: '',
        posisirubrik: '',
        materijadi: '',
        matauang: this.$store.state.user.matauang,
        iscash: 0,
        oncashnote: '',
        jttempo: '',
        gross: 0,
        grossdesc: '',
        diskon: 0,
        diskonpc: 0,
        dpp: 0,
        ppn: 0,
        revlain: 0,
        revlaindesc: '',
        total: 0,
        totaliklan: 0,
        billb4comp: 0,
        proforma: 0,
        billing: 'DI AKHIR',
        billtoadv: 0,
        advnama: '',
        advnpwp: '',
        advaddr1: '',
        advaddr2: '',
        advcity: '',
        advtelp: '',
        accexec: '',
        completeda: null,
        isstoped: 0,
        invoiceno: '',
        invoicedate: null,
        isinvoiced: 0,
        jenisbayar: 'uang',
        keteranganbayar: '',
        posted: 0,
        createby: this.$store.state.user.username,
        compcode: this.$store.state.user.compcode,
      },
      byae:0,
      platforms:[{value:'', text:'-- ALL --'}],
      konteniklans:['Text', 'Foto', 'Video', 'Live TV']
    };
  },
  computed: {
    getTotalKarakter() {
      let jml = 0;
      let jmlbaris = 0;
      for (let i=1;i<=8;i+=1) {
        const val = this.model['baris'+i];
        if (val.length > 0) {
          jmlbaris += 1;
          jml += val.length;
        }
      }
      this.model.jmlbaris = jmlbaris;
      return jml > 9 ? jml.toString() : '0' + jml.toString() || '00';
    },
    invalidOrderLines() {
        this.$v.ordLinesObj.$touch();
        return this.$v.ordLinesObj.$invalid;
    },
    invalidFormdata() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    groupiklan() {
      return this.model.classad;
    },
    gross(){
        return this.model.gross;
    },    
    discpc(){
        return this.model.diskonpc;
    },    
    discvalue(){
        return this.model.diskon;
    },    
    revlain(){
      return this.model.revlain;
    },
    vattotal(){
        return this.model.ppn;
    },    
  },
  watch: {
    gross: function(newval) {
        if (this.model.calcDisc == 1){
          this.model.diskon = parseFloat(newval) * parseFloat(this.model.diskonpc) / 100;;        
        }
        this.calcTaxes();
    },  
    discpc: function(newval) {
        if (this.model.calcDisc == 1){
          this.model.diskon = parseFloat((this.model.gross || 0)) * parseFloat(this.model.diskonpc) / 100;;        
          this.calcTaxes();
        }
    },    
    discvalue: function(newval) {
        if (this.model.calcDisc == 1){
          // this.model.diskonpc = parseFloat(accounting.formatNumber(this.model.diskon/this.model.gross)) * 100;
          this.model.diskonpc = (parseFloat(this.model.diskon)/parseFloat(this.model.gross)) * 100;
        } else if (!(this.model.discpc)){
          this.model.diskonpc = (parseFloat(this.model.diskon)/parseFloat(this.model.gross)) * 100;
        }
        this.calcTaxes();
    },  
    revlain: function(newval) {
        this.calcTaxes();
    },  
    vattotal: function(newval) {
        this.model.total = parseFloat(this.model.dpp) + parseFloat(this.model.ppn);
    },    
  },
  filters: {
    ambilNamaHari(tanggal) {
      const namesDay = [
        "Minggu",
        "Senin",
        "Selasa",
        "Rabu",
        "Kamis",
        "Jumat",
        "Sabtu"
      ];
      const day_ = namesDay[moment(tanggal).day()];
      return day_;
    }
  },  

  created: async function() {
    const routeAsal = localStorage.getItem('opiDbyae');
    if (routeAsal ==  "iklankoran.iklandigitalbyae") {
        this.byae=1;
    }
    if (this.$route.params.orderid)  {
      toastr.info('Loading OPI Detail, please wait')
          this.inputBerlanjut=0;
      try {
        const [f,g,data] = await Promise.all([opi.paymentForms(),opi.platform(), opi.detail(this.$route.params)]) ;
        this.paymentForms=f;
        this.platforms=g;
        const row = data[0];
        this.saveEnabled=(row.posted === 0);
        row.orderdate = row.orderdate ? moment(row.orderdate).format('YYYY-MM-DD') : '';

        for (var key in row) {
            this.model[key] = row[key];
        }
        this.selectedIklan.classad = this.model.classad;
        this.selectedIklan.jiklanid = this.model.jiklanid;
        this.selectedIklan.hargabw = this.model.hargabw;
        this.selectedIklan.hargafc = this.model.hargafc;
        this.selectedIklan.uraian = this.model.uraian_jiklan;

        this.orderLines =data[1];
        this.ordLines.total=this.orderLines.length;
        this.selectedIklan = data[2];

        this.tgl_akan_muat = [];
        this.orderLines.forEach((jd,idx)=>{
          // this.tgl_akan_muat.push(new Date(jd.jadwalmuat));
          this.tgl_akan_muat.push(new Date(moment(jd.jadwalmuat).format('YYYY-MM-DD')));
          // this.tgl_akan_muat.push(jd.jadwalmuat);
          this.orderLines[idx].jadwalmuat = moment(jd.jadwalmuat).format('YYYY-MM-DD');
        });
        // this.minDate = lines && lines.length>0 ? (new Date(lines[0].jadwalmuat) < new Date() ? new Date(lines[0].jadwalmuat) : new Date()) : new Date();

        // this.getGrossDescription();
        toastr.clear;
      } catch (error) {
            console.log('error : ', error);
            toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
      }
    } else {
        this.model.orderdate  = moment().format('YYYY-MM-DD');
        // const [a,f] = await Promise.all([opi.kelompokib(),opi.paymentForms()]) ;
        // this.kelompokIB=a;
        // this.paymentForms=f;
        const [f,g] = await Promise.all([opi.paymentForms(),opi.platform()]) ;
        this.paymentForms=f;
        this.platforms=g;
    }

        this.$watch('model.jmlspot', function(newVal) {
            if (newVal==this.model.jmlspot) {
                setTimeout(() => {
                  this.model.price = parseFloat(this.model.gross) / parseInt(this.model.jmlspot);
                }, 100);
            }
        });            
        this.$watch('model.gross', function(newVal) {
            if (newVal==this.model.gross) {
                setTimeout(() => {
                    this.model.price = parseFloat(this.model.gross) / parseInt(this.model.jmlspot);
                }, 100);
            }
        });            

  },
  methods: {
    calcGross: function() {
        try {   
            if (this.model.grossdesc) {
                let geval=eval;
                let NilaiFix = geval(`${this.model.grossdesc};`);
                this.model.gross =  parseFloat(NilaiFix) || 0;
            } else {
                toastr.info('isi Gross description dg Formula, contoh: (5 * 100 * 100) ','INFO',10000);
            }

        } catch (error) {
            consol.log('geval model.grossdesc : ',error);
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },
    calcTaxes : function() {
        this.model.totaliklan = parseFloat(this.model.gross) - parseFloat(this.model.diskon);
        this.model.dpp = parseFloat(this.model.totaliklan) + parseFloat(this.model.revlain);
        if (this.model.calcVAT == 1){
            this.model.ppn = (this.tarifPPN/100) * this.model.dpp;
        }
      this.model.total = this.model.dpp + parseFloat(this.model.ppn);

        this.$forceUpdate();
    },    

    changeWarna(val) {
      if(this.selectedIklan) {
        if(val==="BW"){
            this.model.price = this.selectedIklan.hargabw;
        } else {
            this.model.price = this.selectedIklan.hargafc;
        }
      } else {
          this.model.price = 0;
      }
      // this.getGrossDescription();
    },
    getGrossDescription () {
        // GET GROSS
          // this.model.grossdesc = `( ${this.model.jmlspot || this.model.jmlmuat} * ${(this.model.price||0).toLocaleString()} )`;
          this.model.grossdesc = `( ${this.model.jmlspot || this.model.jmlmuat} * ${this.model.price} )`;
          const gross = (this.model.jmlspot|| this.model.jmlmuat) * this.model.price;
          this.model.gross = gross;
  
      // GET DISCOUNT
      let disc = parseFloat(accounting.formatNumber(this.model.diskon/this.model.gross)) * 100;
      this.model.diskonpc = isNaN(disc) ? 0 : disc;
      // GET NETTO
      this.model.dpp = this.model.gross - this.model.diskon;
      // GET TAX
      this.model.ppn = (this.tarifPPN/100) * this.model.dpp;
      // GET TOTAL
      this.model.totaliklan = this.model.dpp + this.model.ppn;
      // GET GRAND TOTAL
      this.model.total = this.model.totaliklan + this.model.revlain;
      // GET SILENT DISC %
      let silent_pc = parseFloat(accounting.formatNumber(this.model.silentdisc/this.model.total)) * 100;
      this.model.silent_pc = isNaN(silent_pc) ? 0 : silent_pc;
      // GET TOTAL PAYMENT
      this.total_bayar = this.model.total - this.model.silentdisc;
    },
    handleEnterAmt: function (e) {
      // handle CTRL+ENTER , mengisi otomatis Gross description
      if (e.ctrlKey) {
          this.getGrossDescription();
      }  
    },    
    onSelectLkuCustomer: async function (_selected) {
      this.model.custinfo = _selected.CustName.trim()+ ' | '+_selected.CustCode.trim();
      this.model.customer_id = _selected.customer_id;
      this.model.customer_name = _selected.CustName.trim();
      this.lkuCustomerShow=false;
    },    
    onSelectLkuSalesae: async function (_selected) {
      // this.model.SalesEx = _selected.salesae_id.trim() + ' | ' + _selected.salesae_name.trim();
      this.model.SalesEx = _selected.salesae_name.trim();
      // this.model.accexec = _selected.crewnik;
      this.model.accexec = _selected.salesae_id;
      this.model.salesae_id = _selected.salesae_id;
      // this.model.customer_name = _selected.salesae_name.trim();
      this.lkuSalesaeShow=false;
    },    
    onSelectLkuSo(_selected) {
        this.lkuSoShow=false;
        this.model.calcDisc=0;
        this.model.calcVAT=0;
        this.model.salesHdrKey=_selected.salesHdrKey;
        this.model.salesDtlKey=_selected.salesDtlKey;
        this.model.mediaorder=_selected.nomor;
        if (!(this.model.juduliklan)) {
            this.model.juduliklan=`${_selected.itemname} | ${_selected.description} `;
        }
        this.model.matauang=_selected.matauang;
        this.model.jenisbayar=_selected.jenisbayar;
        this.model.keteranganbayar=_selected.keteranganbayar;
        this.model.custinfo = _selected.CustName.trim()+ ' | '+ _selected.CustCode.trim();
        this.model.customer_id = _selected.customer_id;
        this.model.customer_name = _selected.CustName.trim();
        this.model.Advertiser=_selected.Advertiser;
        this.model.brand=_selected.brand;
        this.model.kategori=_selected.kategori;
        this.model.SalesEx=_selected.SalesEx;
        this.model.accexec=_selected.SalesExCode;
        const platform = this.platforms.find(p=> p.kodesales=_selected.saleCrCode);
        if (platform){
          this.model.platform=platform.platformid;
        }
        const arrJadwal=JSON.parse(_selected.jadwal); 
        // this.model.jmlmuat = arrJadwal.length ;           
        this.model.jmlmuat = _selected.qtyOrder ;           
        this.model.jmlspot= _selected.qtyOrder ;           
        this.tgl_akan_muat = [];
        arrJadwal.forEach((jd,idx)=>{
          this.tgl_akan_muat.push(new Date(jd));
          this.orderLines.push({jadwalmuat: moment(jd).format('YYYY-MM-DD'), jadwalspot:1});
        });
        this.model.iscash=_selected.iscash;
        this.model.proforma=_selected.proforma;
        this.model.billing=_selected.billing;
        this.model.billtoadv=_selected.billtoadv;
        this.model.advnama=_selected.advnama;
        this.model.advnpwp=_selected.advnpwp;
        this.model.advaddr1=_selected.advaddr1;
        this.model.advaddr2=_selected.advaddr2;
        this.model.advcity=_selected.advcity;
        this.model.advtelp=_selected.advtelp;
        // this.model.gross = _selected.grossOrder;
        // this.model.diskon=_selected.discOrder;
        // this.model.diskonpc = _selected.priceDiscPc;
        // this.model.dpp = _selected.nettOrder;
        // this.model.ppn = _selected.nilaippn;
        //  this.model.totaliklan = _selected.nilaidue;
        this.model.gross = _selected.nettSales;
        this.model.totaliklan = _selected.nettSales;
        this.model.total = _selected.nettSales;
        this.model.price = parseFloat(this.model.gross) / parseInt(this.model.jmlspot);
        this.calcTotalDtlOrder();

    },    
    onSelectLkuJenisIklan: async function (_selected) {
      this.model.jiklanid = _selected.jiklanid;
      this.model.jiklan = _selected.jenisiklan;
      this.model.ukuraniklan = _selected.ukuranposisi;
      this.model.posisirubrik = _selected.halamanposisi;
      this.model.materijadi = _selected.konteniklan;
      this.model.ratecard = _selected.harga;
      // this.model.price = parseFloat(this.model.gross) / parseInt(this.model.jmlspot);
      this.model.platform = _selected.platformid;
      this.selectedIklan =  _selected;
      // this.getGrossDescription();
      this.lkuJenisIklanShow=false;
    },    
    clearDate() {
       this.tgl_akan_muat = [];
       this.orderLines = [];
      //  this.getGrossDescription();
    },
    selectDate(val) {
        const date = moment(val.date).format('YYYY-MM-DD');
        const index = this.orderLines.findIndex(line => line.jadwalmuat === date);      
        // const index = this.orderLines.indexOf(date);
        if (index > -1) {
          if (this.orderLines[index].istayang) {
                toastr.error(`Iklan sudah tayang pada tanggal ${date}, tidak bisa diubah/dihapus `,'ERROR MESSAGE',5000);
                this.tgl_akan_muat = [];
                this.orderLines.forEach((jd)=>{
                  this.tgl_akan_muat.push(new Date(jd.jadwalmuat));
                });
                this.$forceUpdate();
          } else {
            this.tgl_akan_muat.splice(index, 1);
            this.orderLines.splice(index, 1);
          }
        } else {
          this.tgl_akan_muat.push(new Date(date));
          this.orderLines.push({jadwalmuat: date});
        }
        // HITUNG QTY MUAT & GROSS DESCRIPTION
        // this.model.jadwalmuat = this.orderLines.length;
        // this.getGrossDescription();
    },    
    sortDate() {
       this.tgl_akan_muat.sort((a, b) => {   
         if ( a < b ){
            return -1;
          }
          if ( a > b ){
            return 1;
          }
          return 0;
      });
       this.orderLines.sort((a, b) => {   
         if ( a.jadwalmuat < b.jadwalmuat ){
            return -1;
          }
          if ( a.jadwalmuat > b.jadwalmuat ){
            return 1;
          }
          return 0;
      });
    },
    closeOrderLines: function(){
        const opened= this.orderLines.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    addOrderLines : function () {
        this.closeOrderLines();
        const obj={_showDetails:true};
        this.ordLines.selected = obj;
        if (this.orderLines.length>0) {
          const contoh = this.orderLines[this.orderLines.length-1];
          this.ordLinesObj.jadwalspot=contoh.jadwalspot;
          this.ordLinesObj.jadwalmuat=moment(contoh.jadwalmuat, 'YYYY-MM-DD').add(1,'days').format('YYYY-MM-DD');
          if (this.orderLines.length==9){
            this.inputLineBerlanjut=0;
          }

        } else {
          this.ordLinesObj.jadwalmuat=moment().format('YYYY-MM-DD');
          this.ordLinesObj.jadwalspot=1;
        }

        this.orderLines.push(obj);
        this.ordLines.total=this.orderLines.length;
        setTimeout(() => {
            const bfore = this.ordLines.page;
            const after =Math.ceil((this.ordLines.total)/this.ordLines.limit);
            if (bfore != after){
                this.ordLines.page =  after;                 
                toastr.info(`Move to page ${after} of total  ${this.ordLines.total} items`,'Line/Detail PR',10000);
            }
        }, 100);    
    },
    editOrderLines : function (obj,callback) {
        this.closeOrderLines();
        this.ordLines.selected = obj;
        for (var key in obj) {
            this.ordLinesObj[key] = obj[key];
        }
        // this.tgl_akan_muat=[];
        callback();
    },
    delOrderLines: function (index) {
        if (index > -1) {
            // this.orderLines.splice(index, 1);
            const posisi = (this.ordLines.page-1)*this.ordLines.limit;
            this.orderLines.splice(posisi+index, 1);
        }
        this.ordLines.total=this.orderLines.length;
        this.calcTotalDtlOrder();
    },
    saveOrderLines: async function (callback) {
        if (this.invalidOrderLines) {
            console.log('validation : ', this.$v.ordLinesObj);
            console.log('model obj : ',this.ordLinesObj);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
          for (var key in this.ordLinesObj) {
              this.ordLines.selected[key] = this.ordLinesObj[key];
          }
          this.calcTotalDtlOrder();
          this.ordLines.selected._showDetails=false;
          if (callback) callback();
          if (this.inputLineBerlanjut==1) {
              this.addOrderLines();
              this.$v.ordLinesObj.$reset();
          }

        }
    },
    calcTotalDtlOrder: function () {
        this.model.jmlmuat = this.orderLines.length;
        this.model.jmljadwal = this.orderLines.length;

        // this.orderLines.forEach( function (trx) {
        //     if (trx.jadwalmuat) {
        //         this.model.jmlspotjadwal += parseInt(trx.jadwalspot);
        //     }
        // });
        this.model.jmlspotjadwal = this.orderLines.reduce((a, b) => a + parseInt(b.jadwalspot), 0);
        if (this.model.jmlspot<this.model.jmlspotjadwal) this.model.jmlspot=this.model.jmlspotjadwal;
        this.model.price = parseFloat(this.model.gross) / parseInt(this.model.jmlspot);

    },

    save: async function (callback) {
      // const user = this.$store.state.user.username;
      // const compcode = this.$store.state.user.compcode;
      if (!(this.saveEnabled)) return;
          this.saveEnabled=false;
          if (this.invalidFormdata) {
            const invalidobj={};
            for (var key in this.$v.model) {
            if (this.$v.model[key].$anyError) {
                if (this.$v.model[key].$anyError==true) invalidobj[key] = this.$v.model[key];
            }
            }        
            console.log('validation model: ', this.model);
            console.log('validation field: ', invalidobj);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
              this.saveEnabled=true;
          } else if (this.orderLines.length==0) {
              toastr.error(`Jadwal Tayang harus diisi!`, "ERROR MESSAGE",5000);
              this.saveEnabled=true;
          } else if ((parseInt(this.model.jmlspotjadwal) - parseInt(this.model.jmlspot))>0) {
              toastr.error(`Jadwal Spot Tayang melebihi Total Spot sesuai kontrak`, "ERROR MESSAGE",5000);
              this.saveEnabled=true;
          } else {
            try {
              if ((parseInt(this.model.jmlmuat) - this.orderLines.length)>0) {
                  toastr.warn(`Frekuensi Tayang tidak sesuai dg Tanggal Jadwal yg diplih ${this.model.jmlmuat} <> ${this.orderLines.length}`,'WARNING MESSAGE',5000);
              }
              const data={};
              for (var key in this.model) {
                  data[key] = this.model[key];
              }
              data.jmljadwal=this.orderLines.length;
              data.orderdate = this.model.orderdate ? moment(this.model.orderdate).format('YYYY-MM-DD') : '';
              data.orderLines=this.orderLines;
              // await opi.save(data);
              // this.close();
                    const hasil= await opi.save(data);
                    toastr.success(`Complete successfully, Order Number ${hasil.orderno}`, "Save OPI",10000);

                    if (this.inputBerlanjut==0){
                        this.close();
                    } else {
                        this.saveEnabled=true;      
                        this.model.jmlspot = 0;
                        this.model.jmlmuat = 0;
                        this.model.gross = 0;
                        this.model.diskon = 0;
                        this.model.diskonpc = 0;
                        this.model.dpp = 0;
                        this.model.ppn = 0;
                        this.model.revlain = 0;
                        this.model.total = 0;
                        this.model.totaliklan = 0;
                        this.model.billtoadv = 0;
                        const keys = ['orderdate','platform','matauang', 'createby','jttempo','jmlspot', 'jmlmuat','ispaket','iscash','jttempo','billb4comp','proforma','billtoadv' ];                                        
                        for (var key in this.model) {
                            if (keys.indexOf(key) == -1) {
                                this.model[key] = '';
                            }
                        }
                        this.orderLines=[];
                        this.$v.model.$reset();                        
                    }

            } catch (error) {
                    this.isLoading=false;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
                this.saveEnabled=true;            
            }
        }
    },    

    close(){
    //   console.log('this.$store.state.prevRoute.name : ',this.$store.state.prevRoute.name);
      // if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'iklankoran.iklandigitalfrm')) {
      //   router.push({name:this.$store.state.prevRoute.name});
      // } else {
           if (this.byae==1) {
             router.push({path: "order-iklan-digital-byae/1"});
           } else {
            router.push({name :'iklankoran.iklandigital'});
           }           
      // }
    }
  },
};
</script>
